import React from 'react'

import FormattedMessage from './FormattedMessage'
import FormattedHTMLMessage from './FormattedHTMLMessage'


type MessageProps = React.HTMLAttributes<HTMLSpanElement> & {
  id?: string
  className?: string
  tag?: string
  text: string | ReactIntlMessage
  html?: boolean
  dataTestId?: string
}

const Message = React.forwardRef<HTMLElement, MessageProps>((props, ref) => {
  const { text, html = false, tag = 'span', dataTestId, ...rest } = props

  if (!text) {
    return null
  }

  if (typeof text === 'string') {
    if (!html) {
      return React.createElement(
        tag,
        {
          ...rest,
          ref,
          'data-testid': dataTestId,
        },
        text
      )
    }

    return (
      React.createElement(tag, {
        dangerouslySetInnerHTML: { __html: text },
        ...rest,
        ref,
        'data-testid': dataTestId,
      })
    )
  }

  const element = html ? FormattedHTMLMessage : FormattedMessage
  const { id: tagId } = rest

  return React.createElement(element, {
    tag,
    tagId,
    dataTestId,
    innerRef: ref,
    ...rest,
    ...text,
  }) // rest should be first coz there can be "values: undefined"
})

Message.displayName = 'Message'


export default Message
